const AutomatedIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89179)">
      <path
        d="M14.9981 13.9961C18.8568 13.9961 21.9961 10.8568 21.9961 6.99806C21.9961 3.13934 18.8568 0 14.9981 0C11.1393 0 8 3.13934 8 6.99806C8 10.8568 11.1393 13.9961 14.9981 13.9961ZM13.2659 6.37665L14.4323 7.5428L16.6485 4.58794C17.3468 3.65707 18.752 4.71291 18.0548 5.64262L15.2306 9.40819C14.9456 9.7879 14.3256 9.92203 13.9058 9.50226L12.0231 7.61948C11.2018 6.79848 12.4431 5.55336 13.2659 6.37665Z"
        fill="white"
      />
      <path
        d="M18.7621 16.0037H11.2305C10.7452 16.0037 10.3516 16.3976 10.3516 16.8826V30H19.641V16.8826C19.641 16.3976 19.2473 16.0037 18.7621 16.0037Z"
        fill="white"
      />
      <path
        d="M6.465 8.41C6.465 10.1953 5.01778 11.6425 3.2325 11.6425C1.44722 11.6425 0 10.1953 0 8.41C0 6.62495 1.44722 5.17773 3.2325 5.17773C5.01778 5.17773 6.465 6.62495 6.465 8.41Z"
        fill="white"
      />
      <path
        d="M29.9962 8.41C29.9962 10.1953 28.549 11.6425 26.7637 11.6425C24.9785 11.6425 23.5312 10.1953 23.5312 8.41C23.5312 6.62495 24.9785 5.17773 26.7637 5.17773C28.549 5.17773 29.9962 6.62495 29.9962 8.41Z"
        fill="white"
      />
      <path
        d="M7.71858 19.7067H6.46454V15.4705C6.46454 13.6733 5.00153 12.219 3.19679 12.2385C1.41792 12.2572 0 13.739 0 15.5186V20.1779C0 22.483 1.86859 24.3516 4.17366 24.3516H6.46454V29.121C6.46454 29.6063 6.85844 29.9999 7.34344 29.9999H8.59749V20.5856C8.59749 20.1006 8.20427 19.7067 7.71858 19.7067Z"
        fill="white"
      />
      <path
        d="M22.2852 19.7067H23.5392V15.4705C23.5392 13.6733 25.0022 12.219 26.8069 12.2385C28.5858 12.2572 30.0037 13.739 30.0037 15.5186V20.1779C30.0037 22.483 28.1351 24.3516 25.8301 24.3516H23.5392V29.121C23.5392 29.6063 23.1453 29.9999 22.6603 29.9999H21.4062V20.5856C21.4062 20.1006 21.7995 19.7067 22.2852 19.7067Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89179">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default AutomatedIcon
